import BnplList from 'components/BnplList/BnplList';
// import Footer from 'components/Footer/Footer';
// import Header from 'components/Header/Header';
import MessageContainer from 'components/MessageContainer/MessageContainer';
import OrderAmountCard from 'components/OrderAmount/OrderAmount';
import { PageContent } from 'components/PageContent/PageContent';
import { CheckoutDataContext } from 'context/merchant-details.context';
import qs from 'query-string';
import React, {
 useCallback, useEffect, useMemo, useRef, useState
} from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Bnpl } from 'services/interfaces/bnpl-data.interface';
import { ICheckoutData, ISessionTokenData } from 'services/interfaces/merchant.interface';
import MerchantService from 'services/merchant.service';
import Checkout from 'components/FieldContainer/Checkout';
import SessionOrderService from 'services/sessionOrder.service';
import { OrderPayload } from 'services/interfaces/order-payload.interface';
import { Error as ValidationError } from 'services/interfaces/checkout-validation.interface';
import Validator from 'components/FieldContainer/Validator';
import LoadingOverlay from 'react-loading-overlay';
// import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
// import SuccessPage from 'pages/successPage';
import GetPaidIndex from 'components/GetPaid/GetPaidIndex';
import OrderDetails from 'components/GetPaid/OrderDetails';
import OpttyDirectHeader from 'components/Header/OpttyDirectHeader';
import { OpttyDirectPageContent } from 'components/OpttyDirectPageContent/OpttyDirectPageContent';
import OrderService from 'services/order.service';
import decode from 'jwt-decode';
import {
  loadOpttyInContext,
  isProviderSupportsInContextMode,
} from 'components/Widget/loadIncontext';
import Error from './assets/images/error.svg';
import Loader from './assets/images/loader.svg';
import './App.css';

interface FormData {
  fname: string;
  lname: string;
  email: string;
  phoneNumber: string;
  streetAddress: string;
  streetAddress2: string;
  city: string;
  country: string;
  state: string;
  region: string;
  postalCode: string;
}

function App() {
  const [checkoutData, setCheckoutData] = useState<ICheckoutData>();
  // console.log('Checkout Data:', checkoutData);
  const [orderData, setOrderData] = useState<OrderPayload>();
  const [selectedBnpl, setSelectedBnpl] = useState<Bnpl>();
  const [isLoading, setIsLoading] = useState(true);
  const [overAllLoading, setOverAllLoading] = useState(false);
  const [error, setError] = useState<any>();
  const [availableBnpls, setAvailableBnpls] = useState(1);
  const [isDeclined, setIsDeclined] = useState(false);
  const [createOrderError, setCreateOrderError] = useState<Error | unknown>();
  const [isCompletingOrder, setIsCompletingOrder] = useState(false);
  const [isAmountChange, setIsAmountChange] = useState(false);
  const defaultValue = checkoutData?.merchant.paymentType;
  const currency = checkoutData?.merchant.currency!;
  const data: FormData = {
    fname: orderData?.customer?.firstName || '',
    lname: orderData?.customer?.lastName || '',
    email: orderData?.customer?.email || '',
    phoneNumber: orderData?.customer?.phoneNumber || '',
    streetAddress: orderData?.billingAddress?.streetAddress || '',
    streetAddress2: orderData?.billingAddress?.streetAddress2 || '',
    city: orderData?.billingAddress?.city || '',
    country: orderData?.billingAddress?.country || '',
    state: orderData?.billingAddress?.state || '',
    region: orderData?.billingAddress?.region || '',
    postalCode: orderData?.billingAddress?.postalCode || '',
  };

  const [formError, setFormError] = useState<ValidationError>();
  const [formData, setFormData] = useState<any>({});
  const isCompletingRef = useRef(false);
  const hasAutoSubmitted = useRef(false);
  const hasFetchedData = useRef(false);

  document.body.setAttribute(
    'style',
    `background: ${checkoutData?.merchant.secondaryColor}`
  );

  const sessionToken = useMemo(
    () => qs.parse(window.location.search).session_token as string,
    []
  );

  const bnplProvider = useMemo(
    () => qs.parse(window.location.search).bnplProvider as string,
    []
  );

  const paymentMethod = useMemo(
    () => qs.parse(window.location.search).payment_method as string,
    []
  );

  const opttyMetaData = useMemo(
    () => qs.parse(window.location.search).opttyMetaData as string,
    []
  );

  const changeOrderAmount = useCallback(
    (amount: any) => {
      if (!amount.target.value) {
        setIsAmountChange(true);
        return;
      }
      const tempCheckOutData = { ...checkoutData };
      if (tempCheckOutData.merchant) {
        tempCheckOutData.merchant = {
          ...tempCheckOutData.merchant,
          orderAmount: amount.target.value,
        };
      }
      setCheckoutData(tempCheckOutData as ICheckoutData);
      setIsAmountChange(false);
    },
    [checkoutData]
  );

  const handleCompleteOrder = useCallback(async () => {
    if (!selectedBnpl) return;
    if (isCompletingRef.current) return;
    isCompletingRef.current = true;
    setIsCompletingOrder(true);
    try {
      const result = Validator.checkoutForm(formData);
      const resultKeys = Object.keys(result);
      if (resultKeys.length > 0) {
        setFormError(result);
        setIsCompletingOrder(false);
        return;
      }
      setFormError(result);
      formData.orderAmount = checkoutData?.merchant.orderAmount;
      formData.initiator = 'e-comm';
      const partitionLocation = checkoutData?.merchant?.partitionLocation;
      formData.partitionLocation = partitionLocation ?? '';
      const data = await MerchantService.completeOrder(
        sessionToken,
        selectedBnpl?.name,
        formData
      );
      if (isProviderSupportsInContextMode(selectedBnpl)) {
        setIsLoading(true);
        loadOpttyInContext(
          {
            ...data,
            currency,
            ...(opttyMetaData && opttyMetaData !== 'undefined' && { opttyMetaData }),
            ...(partitionLocation && { location: partitionLocation }),
          },
          sessionToken,
          OrderService,
          checkoutData?.bnplData?.configuration?.widgetToken || ''
        );
      } else if (
        data.redirectUrl?.startsWith('http://')
        || data.redirectUrl?.startsWith('https://')
      ) {
        // redirect to BNPL page
        window.location.href = data.redirectUrl;
      } else {
        console.error('Blocked a potentially malicious redirect.');
      }
      setIsCompletingOrder(false);
    } catch (error: unknown) {
      console.log('error completing order', error);
      const merchantReference = (decode(sessionToken) as ISessionTokenData)
        .orderReference;
      const orderData = await OrderService.getOrderData(
        null,
        'DECLINED',
        selectedBnpl?.name,
        sessionToken,
        merchantReference
      ).catch(() => null);
      if (orderData) {
        setIsDeclined(true);
      } else {
        setCreateOrderError(error);
      }
    } finally {
      isCompletingRef.current = false;
      setIsCompletingOrder(false);
      setOverAllLoading(false);
    }
  }, [selectedBnpl, formData, checkoutData, sessionToken, opttyMetaData, currency]);

  useEffect(() => {
    if (hasFetchedData.current) return;
    hasFetchedData.current = true;

    // for backward compatibility with previously-generated links
    // if (window.location.pathname.substring(1).split('/')[0] === 'optty-direct') {
    //   window.location.href = window.location.href.replace('optty-direct', 'payment-link');
    // }

    if (!sessionToken) {
      setError('Session token not found');
      setIsLoading(false);
      setOverAllLoading(false);
      return;
    }

    if (paymentMethod) {
      setOverAllLoading(true);
    }

    Promise.allSettled([
      MerchantService.getMerchantAndBnplDetailsBySessionToken(sessionToken),
      SessionOrderService.getOrderData(sessionToken),
    ]).then(([merchantResult, orderResult]) => {
      if (merchantResult.status === 'fulfilled') {
        const checkoutDataResponse = merchantResult.value;
        setAvailableBnpls(checkoutDataResponse.bnplData.bnpls.length);
        setCheckoutData(checkoutDataResponse);
        setSelectedBnpl(
          checkoutDataResponse.bnplData.bnpls.find(({ name }) => name === paymentMethod)
        );
      } else {
        setError(merchantResult.reason?.message);
      }

      if (orderResult.status === 'fulfilled') {
        setOrderData(orderResult.value);
      } else {
        setError(orderResult.reason?.message);
      }

      setIsLoading(false);
      setOverAllLoading(false);
    });
  }, []);

  useEffect(() => {
    if (
      paymentMethod
      && selectedBnpl
      && Object.keys(formData).length
      && !hasAutoSubmitted.current
    ) {
      hasAutoSubmitted.current = true;
      handleCompleteOrder();
    }
  }, [selectedBnpl, formData, handleCompleteOrder]);

  useEffect(() => {
    if (availableBnpls < 1 || isDeclined) {
      setOverAllLoading(false);
      setIsLoading(false);
    }
  }, [availableBnpls, isDeclined]);

  const contextValue = useMemo(
    () => ({
      checkoutData,
      selectedBnpl,
      setSelectedBnpl: (bnpl: Bnpl | undefined) => setSelectedBnpl(bnpl),
      isLoading,
      setIsLoading,
      completeOrder: handleCompleteOrder,
      error,
      setError,
      isCompletingOrder,
      createOrderError,
      // merchantData,
      orderData,
      changeOrderAmount,
      setIsAmountChange,
      isAmountChange,
      formError,
    }),
    [
      checkoutData,
      selectedBnpl,
      isLoading,
      handleCompleteOrder,
      error,
      isCompletingOrder,
      createOrderError,
      // merchantData,
      orderData,
      changeOrderAmount,
      isAmountChange,
      formError,
    ]
  );

  return (
    <BrowserRouter>
      <CheckoutDataContext.Provider value={contextValue}>
        <LoadingOverlay
          active={overAllLoading}
          spinner
          styles={{
            overlay: (base: any) => ({
              ...base,
              position: 'fixed',
            }),
          }}
          text="Loading your content..."
        >
          {/* <Header /> */}
          <OpttyDirectHeader />
          <Routes>
            <Route
              element={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <PageContent>
                  {!isLoading && checkoutData && availableBnpls > 0 && !isDeclined && (
                    <>
                      <OrderAmountCard />
                      <Checkout
                        data={!defaultValue && data}
                        formData={formData}
                        setFormData={setFormData}
                      />
                      <BnplList />
                    </>
                  )}

                  {isLoading && (
                    <MessageContainer
                      headerText="Loading..."
                      icon={Loader}
                      isLoader
                      subText="Please do not refresh the page"
                    />
                  )}

                  {availableBnpls < 1 && (
                    <MessageContainer
                      headerText="This payment method is unavailable"
                      icon={Error}
                      subText="Please select an alternative payment method or return to checkout via the CANCEL button"
                    />
                  )}

                  {isDeclined && (
                    <MessageContainer
                      headerText="We are sorry, your payment was unsuccessful."
                      icon={Error}
                      subText="Please click 'Back to Checkout' to select an alternative payment method."
                    />
                  )}

                  {error && (
                    <MessageContainer
                      headerText="Error Loading Data"
                      icon={Error}
                      subText="Something went wrong"
                    />
                  )}
                </PageContent>
              }
              path="/"
            />
            <Route
              element={(
                <OpttyDirectPageContent>
                  <>
                    <GetPaidIndex />
                  </>
                  <>
                    {error && (
                      <MessageContainer
                        headerText={error}
                        icon={Error}
                        subText="Kindly contact your merchant"
                      />
                    )}
                  </>
                </OpttyDirectPageContent>
              )}
              path="/payment-link/:customization"
            />
            <Route
              element={(
                <OpttyDirectPageContent>
                  <>
                    <OrderDetails bnplProvider={bnplProvider} value={2} />
                  </>
                  <>
                    {error && (
                      <MessageContainer
                        headerText="Error Loading Data"
                        icon={Error}
                        subText="Something went wrong"
                      />
                    )}
                  </>
                </OpttyDirectPageContent>
              )}
              path="/callback"
            />
            <Route
              element={(
                <MessageContainer
                  headerText="Page Not Found"
                  icon={Error}
                  subText="Something went wrong"
                />
              )}
              path="*"
            />
          </Routes>
          <Footer />
        </LoadingOverlay>
      </CheckoutDataContext.Provider>
    </BrowserRouter>
  );
}

export default App;
